import { API_ERRORS_MAP, DEFAULT_ERROR_MESSAGE } from '../client/customErrors';

class ErrorService {
    /**
     * @method
     * @description - Gets error message by code.
     * @param {string} code - Error code.
     * @returns {string} - Error message in locale.
     */
    getErrorMessage(code) {
        return API_ERRORS_MAP[code] || DEFAULT_ERROR_MESSAGE;
    }
}

export default ErrorService;
